/**
 * Canonical store phone numbers (India). Used on Contact, About, Footer, legal pages.
 * tel: must be E.164 without spaces.
 */
export const STORE_PHONE_PRIMARY = {
  display: "+91 93720 20961",
  tel: "+919372020961",
};

/** Second line — +91 91378 39084 (full 10-digit local number after country code). */
export const STORE_PHONE_ALT = {
  display: "+91 91378 39084",
  tel: "+919137839084",
};
